import { StyleSheet,Dimensions } from 'react-native';

import { SEPARATOR_STROKE,SIZES, PALETTE, MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;

export default StyleSheet.create({
 	fourItems:{
		flex:0.27,
		alignItems:'flex-end',
		justifyContent: 'flex-end',
		alignSelf: 'flex-end',
	},
	rowStyles:{
		paddingBottom: 10,
		paddingTop: 10,
		flex:1,
	},
	customTextsize:{
		fontSize:17,
		color:'red',
		backgroundColor:'transparent',
		justifyContent:'center',
	},
	ieDesc:{
		color:PALETTE.secondaryText,
	},
	firstItem:{
		flex:0.19,
		alignItems:'flex-start',
	},
	containerStyle:{
		// flex:1,
		flexDirection:'row',
		paddingRight: 10,
	}
});
